var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.1L13.9 1 8 6.9 2.1 1 1 2.1 6.9 8 1 13.9 2.1 15 8 9.1l5.9 5.9 1.1-1.1L9.1 8 15 2.1z",
    fill: "#AAC4F9",
    stroke: "#AAC4F9",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCloseButton);
export default __webpack_public_path__ + "static/media/ModalCloseButton.7df072252a51e9e2f859b9feb76fc766.svg";
export { ForwardRef as ReactComponent };